"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ClientRequest_1 = __importDefault(require("../ClientRequest"));
const ArticleApi = {
    getArticleDetail: async (articleId) => {
        const res = await ClientRequest_1.default.get(`articles/${articleId}`);
        return res;
    },
    getArticleListComment: async (articleId, page) => {
        const res = await ClientRequest_1.default.get(`articles/${articleId}/comments?page=${page}&per_page=8`);
        return res.data;
    },
    likeArticle: async (articleId) => {
        const res = await ClientRequest_1.default.post(`articles/${articleId}/likes`);
        return res.data;
    },
    unlikeArticle: async (articleId) => {
        const res = await ClientRequest_1.default.delete(`articles/${articleId}/likes`);
        return res.data;
    },
    likeArticleComment: async (commentId) => {
        const res = await ClientRequest_1.default.post(`article-comments/${commentId}/likes`);
        return res.data;
    },
    unlikeArticleComment: async (commentId) => {
        const res = await ClientRequest_1.default.delete(`article-comments/${commentId}/likes`);
        return res.data;
    },
    uploadImage: async (data) => {
        const res = await ClientRequest_1.default.post('articles/upload-image', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    postArticle: async (data) => {
        const res = await ClientRequest_1.default.post('articles', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    editArticle: async (articleId, data) => {
        const res = await ClientRequest_1.default.post(`articles/${articleId}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    getArticleInheritanceMap: async (nodeId) => {
        const res = await ClientRequest_1.default.get(`article-inheritance-map?node_id=${nodeId}`);
        return res;
    },
    RepComment: async (data) => {
        const res = await ClientRequest_1.default.post(`comments`, data);
        return res;
    },
    CommentDetail: async (data) => {
        const res = await ClientRequest_1.default.get(`article-comments/${data?.comment}?page=${data.page}`);
        return res.data;
    },
    deletePostArticle: async (data) => {
        const res = await ClientRequest_1.default.delete(`articles/${data}`);
        return res.data;
    },
    deletePostArticleComment: async (data) => {
        const res = await ClientRequest_1.default.delete(`article-comments/${data}`);
        return res.data;
    },
    editCommentArticle: async (data) => {
        const res = await ClientRequest_1.default.put(`article-comments/${data?.idComment}`, data.data);
        return res.data;
    },
    getArticlePreview: async (data) => {
        const res = await ClientRequest_1.default.post('articles/preview', data);
        return res.data;
    },
};
exports.default = ArticleApi;
